import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as reduxAsyncConnect } from 'redux-connect'

import app, { DOFE_RESET_STATE } from './app'
import auth from './auth'
import api from './api'
import wizard from './wizard'
import files from './files'
import { reducer as form } from 'redux-form'

export default (history/*, params*/) => {

  const appReducer = combineReducers({
    reduxAsyncConnect,
    router: connectRouter(history),
    app,
    auth,
    form,
    files,
    wizard,
    api
  })

  const rootReducer = (state, action) => {
    if (action.type === DOFE_RESET_STATE) {
      state = {
        router: { ...state.router },
        reduxAsyncConnect: { ...state.reduxAsyncConnect },
        app: { ...state.app },
        auth: { ...state.auth },
        api: {
          common: { ...state.api.common },
          persons: {
            locales: state.api.persons.locales
          }
        }
      }
    }

    return appReducer(state, action)
  }

  return rootReducer
}

